import React from 'react'
import { InputText } from '@telavita-core/react-design-kit'
import { MedicalAppointmentFormData } from 'components/MedicalRequestForm/schema'
import { Controller, useFormContext } from 'react-hook-form'

export const ProfessionalNameInput = () => {
  const { control } = useFormContext<MedicalAppointmentFormData>()

  return (
    <Controller
      control={control}
      name="professionalName"
      render={({ field, fieldState: { error } }) => (
        <InputText
          {...field}
          handleClearSearchField={() => field.onChange('')}
          floatingLabel="Nome do médico*"
          hasError={Boolean(error?.message)}
          helperMessage={error?.message}
          helperMessageVariant={error?.message ? 'error' : 'default'}
        />
      )}
    />
  )
}
